import type {AxiosResponse} from 'axios';
import {useQuery} from '@tanstack/react-query';
import {request} from './index.js';
import API_URLS from './urls.ts';
import {DURATION_MS} from './util.js';

const getIMSUserStatus = () =>
  request
    .get(`${API_URLS.ims}/users/me/status`)
    .then((response: AxiosResponse) => response.data);

export const useGetIMSUserStatus = (queryOptions = {}) =>
  useQuery({
    queryKey: ['imsMeStatus'],
    queryFn: getIMSUserStatus,
    staleTime: DURATION_MS.HOUR,
    ...queryOptions,
  });

const getUserById = (userId: string) =>
  request
    .get(`${API_URLS.ims}/users/${userId}`)
    .then((res: AxiosResponse) => res.data);

export const useGetUserById = (userId: string, queryOptions = {}) =>
  useQuery({
    queryKey: ['imsUser', userId],
    queryFn: () => getUserById(userId),
    staleTime: DURATION_MS.HOUR,
    ...queryOptions,
  });

const getProjectInfo = (projectId: string) =>
  request
    .get(`${API_URLS.ims}/projects/${projectId}/info`)
    .then((res: AxiosResponse) => res.data);

export const useGetProjectInfo = (projectId: string, queryOptions = {}) =>
  useQuery({
    queryKey: ['imsProjectInfo', projectId],
    queryFn: () => getProjectInfo(projectId),
    staleTime: DURATION_MS.HOUR,
    ...queryOptions,
  });
